/**
 * Dashboard dates selector.
 *
 * @param {object} state Store state.
 * @returns {Immutable.Map} Dashboard dates data {from, to}.
 */
export const dashboardDates = state => state.dashboards.get('popupDates');
